/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { Stack } from '@mui/material';
/**
 * Stack component implementation with custom styling
 * @param {String} cssClassName - css class name for user defined styling
 * @param {*} children - child elements of the stack
 * @returns
 */
const CustomStack = ({ cssClassName, children }) => (
  <Stack
    direction="column"
    spacing={{ sm: 1, cc: 3, md: 2, lg: 3 }}
    sx={{
      background: 'white',
      borderRadius: 3,
      py: { sm: 1, cc: 3, md: 2, lg: 3 },
    }}
    padding={{ sm: 1, cc: 1, md: 2, lg: 3 }}
    marginLeft={{ md: 1 }}
    minWidth={200}
    className={cssClassName}
  >
    {children}
  </Stack>
);
//
export default CustomStack;
